var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: {
        "value-key": "value",
        multiple: _vm.multiple,
        disabled: _vm.disabled,
        filterable: "",
        clearable: "",
        "popper-class": "popper",
        placeholder: _vm.placeholder,
        "filter-method": _vm.filterOption,
      },
      on: { change: _vm.handleChangeTree },
      model: {
        value: _vm.innerValue,
        callback: function ($$v) {
          _vm.innerValue = $$v
        },
        expression: "innerValue",
      },
    },
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.value,
        attrs: {
          value: item,
          label:
            item.label + (item.describe ? "（" + item.describe + "）" : ""),
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }